import { useEffect, useRef } from "react";

// Pops de historial lanzados por la propia app (no por el usuario), compartido entre paneles.
const shared = { current: 0 };
let ignorar = false;
window.addEventListener("popstate", () => {
  ignorar = shared.current > 0;
  if (ignorar) shared.current -= 1;
});

// Paneles de detalle: el botón «atrás» del navegador (o del móvil) vuelve un paso en lugar de salir de la página.
export function useHistoryBack(open, onStep, { escape = true } = {}) {
  const cb = useRef(onStep);
  cb.current = onStep;
  const depth = useRef(0);
  const expected = shared;
  const api = useRef(null);
  if (!api.current) {
    api.current = {
      push: () => { window.history.pushState({ panel: true }, ""); depth.current += 1; },
      back: () => {
        if (depth.current > 0) { depth.current -= 1; expected.current += 1; window.history.back(); }
        cb.current(depth.current);
      },
      close: () => {
        const n = depth.current;
        depth.current = 0;
        if (n) { expected.current += 1; window.history.go(-n); }
        cb.current(0);
      },
    };
  }
  useEffect(() => {
    if (!open) return undefined;
    window.history.pushState({ panel: true }, "");
    depth.current = 1;
    const onPop = () => {
      if (ignorar) return;
      depth.current = Math.max(0, depth.current - 1);
      cb.current(depth.current);
    };
    const onKey = (e) => { if (e.key === "Escape") api.current.back(); };
    window.addEventListener("popstate", onPop);
    if (escape) window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("popstate", onPop);
      window.removeEventListener("keydown", onKey);
      if (depth.current > 0) { const n = depth.current; depth.current = 0; expected.current += 1; window.history.go(-n); }
    };
  }, [open, escape]); // eslint-disable-line react-hooks/exhaustive-deps
  return api.current;
}
